import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App';

const component =<App/>
const root =document.getElementById('root')

ReactDOM.render(component,root);